export enum DocumentType {
  CONTRACT = 'contract',
  APPLICATION_REQUEST = 'application-request',
  THIRD_PARTIES_DATA_NOTICE = 'third-parties-data-notice',
  FIN_PROVIDER_INFO = 'fin-provider-info',
  LOAN_PASSPORT = 'loan-passport',
  AGREEMENT_DECREASE = 'agreement-decrease',
}
